export default "__VITE_ASSET__323bdabf__"